import { render, staticRenderFns } from "./CiVehicleFeaturesList.vue?vue&type=template&id=336925e1&"
import script from "./CiVehicleFeaturesList.vue?vue&type=script&lang=js&"
export * from "./CiVehicleFeaturesList.vue?vue&type=script&lang=js&"
import style0 from "./CiVehicleFeaturesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports